import React, { useRef, useEffect, useCallback } from 'react';

/**
 * Reusable modal prompting users to upgrade to Pro.
 * Can be triggered by any Pro-only feature.
 */
function ProUpgradeModal({
  isOpen,
  onClose,
  feature = 'this feature',
  title = 'Upgrade to Pro',
  description = null,
}) {
  const modalRef = useRef(null);

  // Close on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen, onClose]);

  // Close on click outside
  const handleBackdropClick = useCallback((e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  }, [onClose]);

  if (!isOpen) return null;

  const defaultDescription = `Upgrade to Pro to ${feature}, get daily email alerts for new projects, and export data.`;

  return (
    <div className="pro-upgrade-modal-backdrop" onClick={handleBackdropClick}>
      <div className="pro-upgrade-modal" ref={modalRef} role="dialog" aria-modal="true">
        <button 
          className="pro-upgrade-modal__close" 
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path 
              d="M2 2L18 18M2 18L18 2" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round"
            />
          </svg>
        </button>

        <div className="pro-upgrade-modal__content">
          <div className="pro-upgrade-modal__icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
            </svg>
          </div>
          <h3>{title}</h3>
          <p>{description || defaultDescription}</p>
          <a href="/subscribe" className="pro-upgrade-modal__btn">
            Get Pro
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProUpgradeModal;
